export default {
	zhuye: 'Home',
	qingshururiqi: 'Please Input Date!',
	shengdanshibailianxikefu: 'Failed to generate order, please contact customer service！',
	jipiao: 'Flight Ticket',
	tongguo: 'via',
	changlvkehao: 'Frequent Flyer No.',
	zhongzhuanzai: 'Transit In',
	zhongzhuanshijian: 'Transit Time',
	kenengxuyaolvxingzhengjian: 'Travel Documents/Visas may be required.',
	xinglitongguo: 'Baggage Checked Through',
	jiudian: 'HOTELS',
	lvyoutaopiao: 'Travel Packages',
	dumiyue: 'Go Honeymoon',
	remenyouhui: 'Hot Deals',
	chakanquanbu: 'View all',
	tebietaopiao: 'Special Package',
	lvyouxinxi: 'Travel Info',
	gouwuzhongxin: 'Mall',
	hangban: 'Flight ',
	chengkeziliao: 'Passenger Details',
	fuyingchanpin: 'Add Ons',
	queren: 'Confirmation',
	fukuan: 'Payments',
	chenggong: 'Successful',
	xuanzehangban: 'Selected Flight',
	piaojiaguize: 'Fare Rules & Remarks',
	piaojiaguizes: 'Fare Rules',
	feiwang: 'Flight to ',
	fanhui: 'Back',
	xiayibu: 'Next',
	gengduoxijie: 'More',
	yincangxijie: 'Less',
	gengduo: 'More',
	gengshao: 'Less',
	genggaihangban: 'Change Flight',
	jishangfuwu: 'in-flight Services',
	boyinqi: 'Boeing 777-300ER',
	yihaohangzhan: 'Terminal 1',
	suoyoufeixingshijian: 'All flight time is displayed in 24-hour system.',
	xinguanfeiyan:
		'Regarding to the latest development of COVID-19 in different countries, we recommend transit passengers to check on the up-to-date airport policy at your transit airport, along with the entry restrictions of your final destination, before purchasing flight tickets.',
	zhongyingbuyizhi:
		'If there is any inconsistency between the English version and the Chinese version of destination and airline names, the English version shall prevail.',
	mingzitishi: 'Passenger Given / First & Middle name must be entered exactly as shown on passport(s) or other valid travel document(s).',
	xingshitishi: 'Passenger Family / Last name must be entered exactly as shown on passport(s) or other valid travel document(s).',
	huzhaohaomatishi: 'Your passport number is required for this airline.',
	yudingchenggong: 'Booking Successful!',
	nindeyudingyishibai: 'Your reservation has failed, please place a new order',
	yudingshibai: 'Booking Failed',
	yudingcankao: 'Booking reference:',
	nindeyudingyiqueren: 'Your booking has been confirmed. A confirmation email has been sent to ',
	ninyekyguanliwodeyuding: 'You may also manage your flight bookings in "My Booking".',
	piaojia: 'Ticket Price',
	gongxianghangsi: 'Code Share',
	caozuotongguo: 'Operating By',
	fanhuitishixinxi: 'If you leave this page, the order will no longer be retained and the price may change. Are you sure  you want to leave?',
	wuxingli: 'No free luggage allowance',
	xingqi1: 'Monday',
	xingqi2: 'Tuesday',
	xingqi3: 'Wednesday',
	xingqi4: 'Thursday',
	xingqi5: 'Friday',
	xingqi6: 'Saturday',
	xingqi0: 'Sunday',
	fareRules: {
		tuipiao: "Refund",
		gaiqi: "Endorse",
		tuigaishuoming: "Refund and Endorse Instructions",
		qifeiqian: "Before Takeoff",
		qifeihou: "After Takeoff",
		buketuipiao: "Non Refundable Tickets",
		buketuishui: "Non Refundable Tax",
		bukegaiqi: "Cannot Endorse",
		mianfeituipiao: "Free Ticket Refund",
		mianfeituishui: "Free Tax Refund",
		mianfeigaiqi: "Free Endorse",
		tuipiaofei: "Refund Fee",
		tuishuifei: "Refund of Tax Fee",
		gaiqifei: "Endorse Fee",
		quanchengweishiyong: "unused tickets",
		quchengyishiyong: "departure ticket(s) used, cancel return ticket(s)",
		chufahangban: "departure flight",
		huichenghangban: "return flight"
	}
};
